import { Button, InPageNotification, Modal } from "@ebsco-ui/ebsco-ui";
import PropTypes from "prop-types";
import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { compose } from "redux";
import sharedMessages from "../../../shared-messages";
import {
  accountRemovalPending,
  forgetPersonalUser
} from "../../store/gdpr/account-removal";
import messages from "./are-you-sure-delete-modal-messages";

import "./are-you-sure-delete-modal.scss";
const block = "are-you-sure-delete-modal";

const AreYouSureDeleteModal = ({
  error,
  isOpen,
  onClose,
  forgetPersonalUsr,
  intl: { formatMessage },
  parentSelector,
  disableDeleteButton
}) => {
  const onDeleteUser = () => {
    forgetPersonalUsr();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalTitle={formatMessage(messages.areYouSureTitle)}
      className={block}
      parentSelector={parentSelector}
    >
      <Modal.Header
        className={`${block}__header`}
        closeButtonProps={{
          title: formatMessage(sharedMessages.close),
          onClick: onClose
        }}
      >
        <h2 className={`${block}__title`}>
          {formatMessage(messages.areYouSureTitle)}
        </h2>
      </Modal.Header>
      <Modal.Body className={`${block}__body`}>
        <InPageNotification
          className={`${block}__notification`}
          variant="warning"
        >
          <InPageNotification.Header role="none">
            {formatMessage(messages.warningMessage)}
          </InPageNotification.Header>
          <InPageNotification.Description>
            {formatMessage(messages.warningMessageExplanation)}
          </InPageNotification.Description>
        </InPageNotification>
        {error && (
          <InPageNotification
            className={`${block}__notification`}
            variant="error"
          >
            {formatMessage(sharedMessages.somethingWentWrong)}
          </InPageNotification>
        )}
        <div className={`${block}__main`}>
          <h3 className={`${block}__main-title`}>
            {formatMessage(messages.areYouSureListTitle)}
          </h3>
          <ul className={`${block}__list`}>
            {[
              "saveItems",
              "checkoutBooks",
              "accessCredits",
              "accessContent"
            ].map(item => (
              <li key={item}>{formatMessage(messages[item])}</li>
            ))}
          </ul>
          {formatMessage(messages.areYouSureMessage)}
        </div>
      </Modal.Body>
      <Modal.Footer className={`${block}__footer`}>
        <Button
          className={`${block}__delete-button`}
          onClick={onDeleteUser}
          styleType="default"
          disabled={disableDeleteButton}
        >
          {formatMessage(messages.deleteButton)}
        </Button>
        <Button
          className={`${block}__cancel-button`}
          onClick={onClose}
          styleType="link"
        >
          {formatMessage(sharedMessages.cancel)}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

AreYouSureDeleteModal.defaultProps = { error: false };

AreYouSureDeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  forgetPersonalUsr: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  error: PropTypes.bool,
  disableDeleteButton: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  error: Boolean(state.gdpr.accountRemoval.error),
  disableDeleteButton: accountRemovalPending(state)
});

const mapDispatchToProps = { forgetPersonalUsr: forgetPersonalUser };

export { AreYouSureDeleteModal };
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(AreYouSureDeleteModal);
